import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import {
  Box,
  Button,
  Pagination,
  PaginationItem,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from '@mui/material';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import {
  DataGrid,
  // gridPaginationRowCountSelector,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

import NoteAddIcon from '@mui/icons-material/NoteAdd';

// import { setHistory } from '../../../redux/history';
import moment from 'moment';
// import { resetHistory } from '../../../redux/history';
// import FailModal from '../common/FailModal';
// import ProjectSubSubComponent from './ProjectSubSubCompoent';
import { getParameter } from '../../utils/Utils';
import { Herbaladr_SERVER } from '../../Config';
import axios from 'axios';

const HerbalAdrList = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const user = useSelector((state) => state.user.userData);
  // const [rowSelectionModel, setRowSelectionModel] = useState();

  // Confirm dialog state
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [targetId, setTargetId] = useState(null);

  const handleOpenConfirm = useCallback((e, rowId) => {
    e.stopPropagation();
    setTargetId(rowId);
    setConfirmDialogOpen(true);
  }, []);

  const handleCloseConfirm = useCallback(() => {
    if (deleting) return;
    setConfirmDialogOpen(false);
    setTargetId(null);
  }, [deleting]);

  const handleConfirmDelete = useCallback(async () => {
    if (!targetId) return;
    setDeleting(true);
    try {
      // console.log(targetId);
      // TODO: 실제 삭제 API 엔드포인트로 교체
      await axios.delete(`${process.env.REACT_APP_SERVER}${Herbaladr_SERVER}/${targetId}`).then((res) => {
        if (res.data === 'ok') {
          // TODO: 삭제 성공 후 목록 갱신 방법 선택
          props.reloadList();
        }
      });

      setConfirmDialogOpen(false);
      setTargetId(null);
    } catch (err) {
      console.error(err);
      // TODO: 에러 스낵바/알림
    } finally {
      setDeleting(false);
    }
  }, [targetId]);

  const column = [
    { sortable: true, field: 'no', headerName: 'No', flex: 0, width: 80, editable: false },
    {
      field: 'groupName',
      headerName: 'Organization',
      flex: 1.5,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => params,
    },
    { field: 'patientInitial', headerName: 'Patient Initial', headerAlign: 'center', align: 'center', flex: 1 },
    { field: 'gender', headerName: 'Gender', headerAlign: 'center', align: 'center', flex: 0.5 },
    { field: 'age', headerName: 'Age', headerAlign: 'center', align: 'center', flex: 0.5 },
    { field: 'weight', headerName: 'Weight', headerAlign: 'center', align: 'center', flex: 0.5 },
    { field: 'height', headerName: 'Height', headerAlign: 'center', align: 'center', flex: 0.5 },
    {
      field: 'modifyDate',
      headerName: 'Date',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => moment(params).format('YYYY.MM.DD  HH:mm'),
    },
    {
      field: 'id',
      headerName: '',
      headerAlign: 'center',
      width: 82,
      renderCell: (params) => {
        const rowId = params.id; // DataGrid가 사용하는 식별자 (getRowId 설정 반영)

        return (
          <>
            <Stack direction="row" spacing={0.5}>
              <Tooltip title="수정" arrow>
                <IconButton
                  aria-label="modify"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/herbaladr/addherbalard?objId=${rowId}&groupId=${params.row.groupId}`, {
                      state: { objId: rowId },
                    });
                  }}
                  sx={{
                    color: 'info.main',
                    transition: 'all 120ms ease',
                    '&:hover': { bgcolor: 'info.light', color: 'info.contrastText' },
                    '&:active': { bgcolor: 'info.dark', color: 'info.contrastText', transform: 'scale(0.96)' },
                    '&:focus-visible': { outline: '2px solid', outlineColor: 'info.main', outlineOffset: 2 },
                  }}
                >
                  <ModeEditIcon fontSize="small" />
                </IconButton>
              </Tooltip>

              <Tooltip title="삭제" arrow>
                <IconButton
                  aria-label="delete"
                  size="small"
                  onClick={(e) => handleOpenConfirm(e, rowId)}
                  sx={{
                    color: 'error.main',
                    transition: 'all 120ms ease',
                    '&:hover': { bgcolor: 'error.light', color: 'error.contrastText' },
                    '&:active': { bgcolor: 'error.dark', color: 'error.contrastText', transform: 'scale(0.96)' },
                    '&:focus-visible': { outline: '2px solid', outlineColor: 'error.main', outlineOffset: 2 },
                  }}
                >
                  <DeleteForeverIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          </>
        );
      },
    },
  ];

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Pagination
        color="primary"
        variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    );
  }

  return (
    <div>
      <Grid container>
        <Grid size={12}>
          <div>
            <div style={{ float: 'left', fontSize: '20px', paddingLeft: '8px' }}>
              <b>{props.rows ? props.rows.length : ''}</b> Result(s)
            </div>
            <Button
              variant="contained"
              size="small"
              startIcon={<NoteAddIcon />}
              style={{
                height: '100%',
                textTransform: 'none',
                float: 'right',
              }}
              onClick={() => {
                // setOpenPost(true)
                navigate(`/herbaladr/addherbalard?groupId=${getParameter('groupId')}`, {
                  state: { groupId: state === null ? user.group : state.group },
                });
              }}
            >
              Create
            </Button>
          </div>
        </Grid>
        <Grid size={12}>
          <Box style={{ height: '720px', maxHeight: '720px', width: '100%', marginTop: 8 }}>
            <DataGrid
              sx={{ height: '100%' }}
              getRowId={(row) => row['_id']}
              rowHeight={36}
              columns={column}
              rows={props.rows}
              initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
              slots={{ pagination: CustomPagination }}
              pageSizeOptions={[5, 10, 20, 50]}
              pagination
              disableColumnSelector
              showCellVerticalBorder
              disableRowSelectionOnClick
            />
          </Box>
        </Grid>
      </Grid>
      {/* Confirm Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirm}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">삭제 확인</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            정말로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirm} disabled={deleting}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
            disabled={deleting}
            startIcon={deleting ? <CircularProgress color="inherit" size={18} /> : null}
            autoFocus
          >
            {deleting ? 'Deleting...' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default HerbalAdrList;
